"use client";

import { useEffect } from "react";

const RELOAD_KEY = "tezam_global_error_reload_once";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    useEffect(() => {
        console.error("[tezam global error]", error);
        if (typeof window === "undefined") return;
        try {
            if (sessionStorage.getItem(RELOAD_KEY) === "1") return;
            sessionStorage.setItem(RELOAD_KEY, "1");
            window.location.reload();
        } catch {
            /* ignore */
        }
    }, [error]);

    return (
        <html lang="ru">
            <body
                style={{
                    margin: 0,
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontFamily: "system-ui, sans-serif",
                    background: "#f8fafc",
                    color: "#0f172a",
                }}
            >
                <div style={{ textAlign: "center", padding: 24, maxWidth: 420 }}>
                    <h1 style={{ fontSize: 22, margin: "0 0 12px" }}>Ошибка загрузки TEZAM</h1>
                    <p style={{ color: "#64748b", lineHeight: 1.45, margin: "0 0 16px" }}>
                        Обновите страницу. Если проблема повторяется — очистите кэш браузера для tezam.by.
                    </p>
                    <button
                        type="button"
                        onClick={() => {
                            try {
                                sessionStorage.removeItem(RELOAD_KEY);
                            } catch {
                                /* ignore */
                            }
                            window.location.href = "/";
                        }}
                        style={{
                            border: "none",
                            borderRadius: 10,
                            padding: "10px 18px",
                            background: "#229ed9",
                            color: "#fff",
                            fontWeight: 700,
                            cursor: "pointer",
                        }}
                    >
                        На главную
                    </button>
                    <button
                        type="button"
                        onClick={() => reset()}
                        style={{
                            marginLeft: 8,
                            border: "1px solid #cbd5e1",
                            borderRadius: 10,
                            padding: "10px 18px",
                            background: "#fff",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                    >
                        Ещё раз
                    </button>
                </div>
            </body>
        </html>
    );
}
